<template>
    <div>
        <a-image-preview-group
            v-model:visible="visible"
            v-model:current="current"
            infinite
            :srcList="srcList"
            @close="close"
        />
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';

    const props = defineProps({
        srcList:{
            type:Array,
            default:()=>[]
        },
        visibleImg:{
            type:Boolean,
            default:false,
        }
    })

    const emit = defineEmits(['close'])
    const visible = ref(false)
    const current = ref(1);

    const close = ()=>{
        emit('close',false)
    }

    watch(()=>props.visibleImg,(val)=>{
        visible.value = val
    })

    onMounted(()=>{

    })
</script>

<style lang="scss" scoped>

</style>